module.exports = __webpack_public_path__ + "img/Dr. Washing.3aab6ca3.svg";